// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDGcjnyyF-363SBMBoZhQGkYQfUs4Ix1uY",
    authDomain: "homeservices-63df6.firebaseapp.com",
    projectId: "homeservices-63df6",
    storageBucket: "homeservices-63df6.appspot.com",
    messagingSenderId: "822120518264",
    appId: "1:822120518264:web:4db054b6acc1507bc0138d",
    measurementId: "G-3NJN889MKW"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
